import React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";

const values = [
  {
    title: "Disciplina",
    description: "Constancia en cada proceso para lograr resultados reales.",
  },
  {
    title: "Compromiso",
    description: "Nos involucramos contigo en cada etapa de tu progreso.",
  },
  {
    title: "Comunidad",
    description: "Un entorno que impulsa, apoya y motiva constantemente.",
  },
  {
    title: "Superación",
    description: "Cada día es una oportunidad para ser mejor que ayer.",
  },
  {
    title: "Salud",
    description: "Entrenamiento enfocado en bienestar físico y mental.",
  },
  {
    title: "Profesionalismo",
    description: "Acompañamiento serio, seguro y respaldado por expertos.",
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: "easeOut",
    },
  },
};

export default function ValuesSection() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, md: 8 },
        background:
          "linear-gradient(180deg,#0d0d0f 0%, #111113 40%, #0b0b0c 100%)",
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Box
            sx={{
              mb: { xs: 3.5, md: 5 },
              textAlign: "center",
              maxWidth: 650,
              mx: "auto",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "clamp(28px,7vw,38px)",
                  md: "clamp(38px,5vw,48px)",
                },
                fontWeight: 900,
                color: "#ffffff",
                lineHeight: 1.05,
                letterSpacing: -1.2,
              }}
            >
              Nuestros valores
            </Typography>

            <Typography
              sx={{
                mt: 1.3,
                fontSize: { xs: 14, md: 16 },
                color: "rgba(255,255,255,0.75)",
                lineHeight: 1.7,
                fontWeight: 500,
              }}
            >
              La base de todo lo que hacemos dentro y fuera del entrenamiento.
            </Typography>
          </Box>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Grid container spacing={{ xs: 1.2, md: 2.5 }} justifyContent="center">
            {values.map((item) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                key={item.title}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <motion.div variants={cardVariants} style={{ width: "100%" }}>
                  <Card
                    elevation={0}
                    sx={{
                      width: "100%",
                      minWidth: { xs: 130, md: "auto" },
                      maxWidth: { xs: 170, md: 260 },
                      minHeight: { xs: 64, md: "auto" },
                      borderRadius: "18px",
                      background:
                        "linear-gradient(160deg,#111113 0%,#1a1a1d 60%,#121214 100%)",
                      border: "1px solid rgba(255,255,255,0.06)",
                      transition: "all .35s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 18px 45px rgba(229,9,20,0.18)",
                        border: "1px solid rgba(229,9,20,0.35)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: { xs: "10px !important", md: "19.2px !important" },
                        minHeight: { xs: 64, md: "auto" },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: { xs: "center", md: "flex-start" },
                        justifyContent: { xs: "center", md: "flex-start" },
                        textAlign: { xs: "center", md: "left" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 14.8, md: 17 },
                          fontWeight: 900,
                          color: "#ffffff",
                          letterSpacing: -0.3,
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Typography
                        sx={{
                          display: { xs: "none", md: "block" },
                          mt: 0.9,
                          fontSize: 14,
                          lineHeight: 1.65,
                          color: "rgba(255,255,255,0.72)",
                          fontWeight: 500,
                        }}
                      >
                        {item.description}
                      </Typography>

                      <Box
                        sx={{
                          display: { xs: "none", md: "block" },
                          mt: 1.7,
                          width: 32,
                          height: 3,
                          borderRadius: 2,
                          background:
                            "linear-gradient(90deg,#e50914,#ff2a2a)",
                        }}
                      />
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
}